<template>
  <div class="tbg">
    <div class="tbg__tabs" role="tablist">
      <button type="button" role="tab" class="tbg__tab" :class="{ on: type === 'image' }" @click="type = 'image'">
        <v-icon small>mdi-image-multiple-outline</v-icon>{{ $t('gallery') }}
      </button>
      <button type="button" role="tab" class="tbg__tab" :class="{ on: type === 'color' }" @click="type = 'color'">
        <v-icon small>mdi-format-color-fill</v-icon>{{ $t('color') }}
      </button>
    </div>

    <div v-show="type === 'image'" class="tbg__grid">
      <button
        v-for="(image, i) in images"
        :key="i"
        type="button"
        class="tbg__thumb"
        :class="{ on: !backgroundColor && backgroundImage === image.image }"
        @click="pickImage(image, i)"
      >
        <img :src="image.link" alt="" loading="lazy">
        <span class="tbg__check"><v-icon small>mdi-check</v-icon></span>
      </button>
    </div>

    <div v-if="type === 'color'" class="tbg__colors">
      <button
        v-for="c in swatches"
        :key="c"
        type="button"
        class="tbg__color"
        :class="{ on: backgroundColor && backgroundColor.toLowerCase() === c.toLowerCase() }"
        :style="{ background: c }"
        :title="c"
        @click="pickColor(c)"
      >
        <v-icon v-if="backgroundColor && backgroundColor.toLowerCase() === c.toLowerCase()" small>mdi-check</v-icon>
      </button>
      <label class="tbg__custom" :title="$t('themeCustomColor')">
        <v-icon small>mdi-eyedropper-variant</v-icon>
        <input type="color" :value="backgroundColor || '#e7e7e7'" @change="pickColor($event.target.value)">
      </label>
    </div>
  </div>
</template>

<script>
// Redesigned copy of core/Background.vue (original untouched): inline picker
// instead of a nested dialog. Script is the original (posts `this.$data`),
// so data() keys stay; the swatch list is a computed.
// Mixins
  import General from '@/Mixins/general'
  import store from '@/store'
  export default {
    name: 'ThemeBackground',
    components: {
    },
    mixins: [General],
    data: () => ({
      render: false,
      dialog: false,
      selected: null,
      select: 'setBackgroundStyle',
      selectedColor: null,
      backgroundColor: '#e7e7e7',
      backgroundImage: '/img/background/login.jpg',
      images: [
        {
          image: '/img/background/lock.jpg',
          link: '/img/background/lock.jpg',
        },
        {
          image: '/img/background/login.jpg',
          link: '/img/background/login.jpg',
        },
        {
          image: '/img/background/1.jpg',
          link: '/img/background/1.jpg',
        },
        {
          image: '/img/background/2.jpg',
          link: '/img/background/2.jpg',
        },
        {
          image: '/img/background/3.jpg',
          link: '/img/background/3.jpg',
        },
        {
          image: '/img/background/4.jpg',
          link: '/img/background/4.jpg',
        },
        {
          image: '/img/background/5.jpg',
          link: '/img/background/5.jpg',
        },
        {
          image: '/img/background/6.jpg',
          link: '/img/background/6.jpg',
        },
        {
          image: '/img/background/7.jpg',
          link: '/img/background/7.jpg',
        },
        {
          image: '/img/background/8.jpg',
          link: '/img/background/8.jpg',
        },
        {
          image: '/img/background/9.jpg',
          link: '/img/background/9.jpg',
        },
        {
          image: '/img/background/10.jpg',
          link: '/img/background/10.jpg',
        },
        {
          image: '/img/background/11.jpg',
          link: '/img/background/11.jpg',
        },
      ],
      type: 'image',
    }),
    computed: {
      swatches () {
        return [
          '#f2f3f7', '#e7e7e7', '#eef4ff', '#e8f5e9', '#fff8e1', '#fce4ec',
          '#ede7f6', '#e0f7fa', '#263238', '#1e1e1e', '#0d47a1', '#004d40',
        ]
      },
    },
    watch: {
      backgroundColor (val) {
      },
    },
    beforeMount () {
      var store = this.$store.state
      this.backgroundColor = store.backgroundColor
      this.backgroundImage = store.backgroundImage
      if (this.backgroundImage) {
        this.type = 'image'
        var index = this.images.findIndex(x => x.image === this.backgroundImage)
        if (index !== -1) {
          this.selected = index
        }
      }
      if (this.backgroundColor && !this.backgroundImage) {
        this.type = 'color'
      }
      if (!this.backgroundColor && !this.backgroundImage) {
        this.type = 'image'
        this.backgroundImage = '/img/background/lock.jpg'
      }
      this.render = true
    },
    mounted () {
    },
    methods: {
      pickImage (image, i) {
        this.selected = i
        this.selectImage(image)
      },
      pickColor (hex) {
        this.selectedColor = { hex: hex }
        this.selectColor()
      },
      selectColor () {
        if (!this.render && !this.selectedColor && !this.selectedColor.hex) return false
        var val = this.selectedColor.hex
        var storage = JSON.parse(localStorage.getItem('token'))
        if (val) {
          this.backgroundColor = val
          this.backgroundImage = null
          storage.init.backgroundColor = val
          storage.init.backgroundImage = null
          store.commit('SET_BACKGROUNDCOLOR', val)
          store.commit('SET_BACKGROUNDIMAGE', null)
          localStorage.setItem('token', JSON.stringify(storage))
          this.store()
        } else {
          this.backgroundColor = null
          storage.init.backgroundColor = null
          localStorage.setItem('token', JSON.stringify(storage))
          store.commit('SET_BACKGROUNDCOLOR', null)
        }
      },
      selectImage (item) {
        if (!this.render) return false
        if (item) {
          this.backgroundColor = null
          this.backgroundImage = item.image
          var storage = JSON.parse(localStorage.getItem('token'))
          // storage.init.backgroundColor = null
          storage.init.backgroundImage = item.image
          store.commit('SET_BACKGROUNDCOLOR', null)
          store.commit('SET_BACKGROUNDIMAGE', item.image)
          localStorage.setItem('token', JSON.stringify(storage))
          this.store()
        }
      },
      store () {
        var app = this
        app.$axios.post(this.$endpoint + 'setting', this.$data)
          .then(res => {
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
      },
    },
  }
</script>

<style scoped>
.tbg__tabs {
  display: flex;
  padding: 3px;
  gap: 2px;
  margin-bottom: 10px;
  background: #eef1f6;
  border-radius: 6px;
}
.theme--dark .tbg__tabs {
  background: #2a2a2a;
}
.tbg__tab {
  flex: 1 1 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 32px;
  border-radius: 6px;
  font-size: 0.8rem;
  color: #5b6475;
}
.tbg__tab .v-icon {
  color: inherit !important;
}
.tbg__tab.on {
  background: #fff;
  color: var(--tss-primary, #0066ff);
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.08);
}
.theme--dark .tbg__tab.on {
  background: #1e1e1e;
}
.tbg__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  max-height: 248px;
  overflow-y: auto;
  padding: 2px;
}
.tbg__thumb {
  position: relative;
  aspect-ratio: 16 / 10;
  border-radius: 6px;
  overflow: hidden;
  background: #eef1f6;
  box-shadow: 0 0 0 1px #e2e6ee;
  transition: box-shadow 0.15s, transform 0.15s;
}
.tbg__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.tbg__thumb:hover {
  transform: translateY(-1px);
  box-shadow: 0 0 0 1px #c9d1dd, 0 4px 10px rgba(16, 24, 40, 0.12);
}
.tbg__thumb.on {
  box-shadow: 0 0 0 2px var(--tss-primary, #0066ff);
}
.tbg__check {
  position: absolute;
  top: 5px;
  inset-inline-end: 5px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: none;
  align-items: center;
  justify-content: center;
  background: var(--tss-primary, #0066ff);
}
.tbg__thumb.on .tbg__check {
  display: inline-flex;
}
.tbg__check .v-icon {
  color: #fff !important;
}
.tbg__colors {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(40px, 1fr));
  gap: 8px;
}
.tbg__color,
.tbg__custom {
  aspect-ratio: 1;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.08);
  transition: transform 0.15s, box-shadow 0.15s;
}
.tbg__color:hover,
.tbg__custom:hover {
  transform: scale(1.06);
}
.tbg__color.on {
  box-shadow: 0 0 0 2px var(--tss-primary, #0066ff);
}
.tbg__color .v-icon {
  color: #0066ff !important;
  mix-blend-mode: difference;
}
.tbg__custom {
  position: relative;
  cursor: pointer;
  background: conic-gradient(#f44336, #ffeb3b, #4caf50, #00bcd4, #3f51b5, #e91e63, #f44336);
}
.tbg__custom .v-icon {
  color: #fff !important;
  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.4));
}
.tbg__custom input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}
</style>
